import React from 'react'
import { Link } from "react-router-dom"
import { motion } from "motion/react"
import { FaUserCog, FaSuitcase } from "react-icons/fa"

const cards = [
  { to: "/projects", label: "Projects", Icon: FaUserCog },
  { to: "/experience", label: "Experience", Icon: FaSuitcase },
]

const PandE = () => {
  return (
    <section className="mx-auto grid max-w-2xl grid-cols-1 gap-4 px-6 py-16 sm:grid-cols-2">
      {cards.map(({ to, label, Icon }) => (
        <motion.div key={to} whileHover={{ y: -4 }} transition={{ type: "spring", stiffness: 300, damping: 30 }}>
          <Link
            to={to}
            className="flex items-center justify-center gap-3 rounded-lg border border-ink-800 bg-ink-900 py-8 font-mono text-lg text-mist-100"
          >
            <Icon size={22} className="text-signal-400" />
            {label}
          </Link>
        </motion.div>
      ))}
    </section>
  )
}

export default PandE
